import { Box, CircularProgress, Typography } from "@mui/material";
import { Dialog } from "components/Dialog";
import { useMemo } from "react";
import { ReturnArrowIcon } from "components/ReturnArrowIcon";

type DocumentPreviewDialogProps = {
  open: boolean;
  fileName: string;
  onClose: () => void;
  previewUrl?: string;
  loading?: boolean;
};

export function DocumentPreviewDialog({
  open,
  fileName,
  onClose,
  previewUrl,
  loading = false,
}: DocumentPreviewDialogProps) {
  const content = useMemo(() => {
    if (loading) {
      return (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    if (!previewUrl) {
      return (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            No preview available.
          </Typography>
        </Box>
      );
    }

    return (
      <iframe
        title={fileName}
        src={previewUrl}
        style={{ width: "100%", height: "100%", border: 0 }}
      />
    );
  }, [fileName, loading, previewUrl]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      title={fileName}
      noPrimaryAction
      closeIcon={<ReturnArrowIcon />}
    >
      <Box sx={{ height: (theme) => theme.spacing(100) }}>{content}</Box>
    </Dialog>
  );
}
